var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"auth row vh-100 text-center"},[_c('b-col',{staticClass:"col-12 my-auto"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }